import {PageTemplate} from '../../shared/layout/PageTemplate';
import {NotificationList} from './components/NotificationList';
import {useTranslation} from "react-i18next";

export function Notification() {
    const {t} = useTranslation();
    return <PageTemplate pageName={`${t('notifications.notifications')}`} title={`${t('notifications.notifications')}`}
                         content={<NotificationList/>}/>
}
